import React from 'react';
import { AboutHomeInformation } from '../../../../types/globalTypes';
import { Text, Title } from '../../../../components';
import styled from 'styled-components';
import { COLORS, device, FONTS } from '../../../../constants';
import AboutItemCard from './AboutItemCard';

interface AboutProps {
  aboutInfo: AboutHomeInformation;
}

const About = ({ aboutInfo }: AboutProps) => {
  return (
    <AboutWrapper>
      <Title
        title={aboutInfo.Title}
        fontFamily={FONTS.TITLE}
        size={36}
        lineHeight={46}
        color={COLORS.SECTION_TITLE}
        isAnimated={true}
      />
      <AboutContent>
        <AboutDescription>
          <Text
            text={aboutInfo.Subtitle}
            fontFamily={FONTS.SUBTITLE}
            size={22}
            lineHeight={28}
            color={COLORS.SECTION_TEXT}
            isAnimated={true}
          />
        </AboutDescription>
        {aboutInfo.AboutItems &&
          aboutInfo.AboutItems.map(item => (
            <AboutItemCard key={item.id} item={item} />
          ))}
      </AboutContent>
    </AboutWrapper>
  );
};
const AboutWrapper = styled.div`
  > span {
    display: block;
    margin-bottom: 60px;
    @media screen and ${device.md} {
      margin-bottom: 30px;
      font-size: 25px;
      line-height: 30px;
    }
    @media screen and ${device.sm} {
      margin-bottom: 20px;
    }
  }
`;
const AboutContent = styled.div`
  display: grid;
  width: 100%;
  gap: 40px;
  grid-template-columns: repeat(6, 1fr);
  @media screen and ${device.lg} {
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
  }
  @media screen and ${device.md} {
    gap: 20px;
  }
  @media screen and ${device.bsm} {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const AboutDescription = styled.div`
  grid-column: 1 / span 3;
  @media screen and ${device.lg} {
    grid-column: 1 / span 2;
    > h4 {
      font-size: 18px;
    }
  }
  @media screen and ${device.md} {
    > h4 {
      font-size: 16px;
      line-height: 20px;
    }
  }
  @media screen and ${device.bsm} {
    grid-column: 1 / span 3;
  }
`;
export default About;
